import { ISectionOptions } from 'docx'
import { Resume } from '@/types/resume/v1'
import work from './parts/work/work'
import projects from './parts/projects/projects'
import volunteer from './parts/volunteer/volunteer'
import references from './parts/references/references'
import skills from './parts/skills/skills'
import education from './parts/education/education'
import languages from './parts/languages/languages'
import awards from './parts/awards/awards'
import certificates from './parts/certificates/certificates'
import publications from './parts/publications/publications'
import interests from './parts/interests/interests'
import additional from './parts/additional/additional'
import basics from './parts/basics/basics'
import classicBasics from './parts/basics/classicBasics'

interface IResumeSection {
  [sectionName: string]: (resume: Resume.Schema) => ISectionOptions
}

interface ITemplateOption {
  structure: IResumeSection
  basics: (basics: Resume.Basics) => ISectionOptions[]
}

/**
 * Here we can define the section structure (and order) for each template type.
 */
const TemplateStructure: Record<string, IResumeSection> = {
  Basic: {
    work,
    projects,
    volunteer,
    references,
    skills,
    education,
    languages,
    awards,
    certificates,
    publications,
    interests,
    additional,
  },
  Classic: {
    work,
    projects,
    volunteer,
    references,
    skills,
    education,
    languages,
    awards,
    certificates,
    publications,
    interests,
    additional,
  },
  Student: {
    education,
    projects,
    work,
    languages,
    skills,
    volunteer,
    references,
    awards,
    certificates,
    publications,
    interests,
    additional,
  },
}

const TemplateOptionsMap: Record<string, ITemplateOption> = {
  basic: {
    structure: TemplateStructure.Basic,
    basics: basics,
  },
  basicalt: {
    structure: TemplateStructure.Basic,
    basics: basics,
  },
  classic: {
    structure: TemplateStructure.Classic,
    basics: classicBasics,
  },
  modernprofessional: {
    structure: TemplateStructure.Classic,
    basics: classicBasics,
  },
  modernstudent: {
    structure: TemplateStructure.Student,
    basics: classicBasics,
  },
}

export const getTemplateConfig = (meta?: Resume.Meta): ITemplateOption => {
  const templateName = meta?.template || 'basic'

  const {
    structure,
    basics
  } = TemplateOptionsMap[templateName] || TemplateOptionsMap.basic

  return {
    structure,
    basics,
  }
}
